import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 9, fontFamily: "Helvetica", paddingTop: 6 },
  section: { marginBottom: 10 },
  title: { fontSize: 16, textAlign: "center", marginBottom: 10 },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  schoolInfo: { flex: 1, alignItems: "center", marginLeft: -15 },
  table: {
    fontSize: 8,
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: 4,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { flexDirection: "row" },
  tableColHeader: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColHeadergender: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColHeaderlate: {
    textAlign: "right",
    width: "13%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColHeaderregistration: {
    width: "22%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColcandidateindex: {
    width: "23%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColnameindex: {
    width: "25.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableColindxheader: {
    width: "11.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
  },
  tableCol: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColgender: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableCollate: {
    textAlign: "right",
    width: "13%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColregistration: {
    textAlign: "right",
    width: "22%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColindx: {
    width: "11.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColcandindx: {
    width: "23%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColname: {
    width: "25.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableFooterRow: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
  },
  tableFooterCol: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    fontWeight: "bold",
    textAlign: "right",
  },
  label: { fontWeight: "bold", marginBottom: 0 },
  separator: { borderBottom: "1 solid black", marginVertical: 5 },
  separator2: { borderBottom: "1 solid black", marginVertical: 3 },
  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
  },
});

const AnnexurePDF = ({
  modalData,
  modalchallan,
  schoolCode,
  schoolName,
  annexureDateTime,
}) => {
  // Calculate total fees dynamically
  const totalFees = modalData.reduce((sum, student) => {
    const regFee = Number(student.exaM_FEES || 0);
    const lateFee = Number(student.latE_FEE || 0);
    return sum + regFee + lateFee;
  }, 0);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ width: 150, alignSelf: "flex-end" }}>
          <Text style={{ fontSize: 8, textAlign: "right" }}>
            <Text style={{ fontWeight: "bold" }}>Generated On:</Text>{" "}
            {annexureDateTime}
          </Text>
        </View>

        <View style={styles.header}>
          <Image
            src="../assets/images/jac-academic-council.png"
            style={{ width: 40, height: 40 }}
          />
          <View style={styles.schoolInfo}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>
              Jharkhand Academic Council, Ranchi
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={{ fontWeight: "bold" }}>Class IX Annexure -</Text>
              &nbsp;2026 (Annual)
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={{ fontWeight: "bold" }}>School Code: </Text>
              {schoolCode}
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={{ fontWeight: "bold" }}>School Name: </Text>
              {schoolName}
            </Text>
          </View>
        </View>

        <View style={styles.separator} />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "-5px",
          }}
        >
          <Text style={styles.section}>
            <Text style={styles.label}>Challan No: </Text>{" "}
            {modalchallan.challaN_NO}
          </Text>
          <Text style={styles.section}>
            <Text style={styles.label}>Challan Generated On: </Text>
            {modalchallan.challaN_ENTRY_DATE} |{" "}
            {modalchallan.challaN_ENTRY_TIME}
          </Text>
        </View>

        <View style={styles.separator2} />

        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            <Text style={styles.tableColindxheader}>SL. No.</Text>
            <Text style={styles.tableColcandidateindex}>Candidate ID</Text>
            <Text style={styles.tableColnameindex}>Candidate's Name</Text>
            <Text style={styles.tableColHeadergender}>Gender</Text>
            <Text style={styles.tableColHeader}>Caste</Text>
            <Text style={styles.tableColHeader}>Category</Text>
            <Text style={styles.tableColHeaderregistration}>
              Registration Fees
            </Text>
            <Text style={styles.tableColHeaderlate}>Late Fees</Text>
            <Text style={styles.tableColHeaderlate}>Total</Text>
          </View>

          {/* Table Rows */}
          {modalData.map((student, idx) => (
            <View style={styles.tableRow} key={idx}>
              <Text style={styles.tableColindx}>{idx + 1}</Text>
              <Text style={styles.tableColcandindx}>
                {student.candidatE_ID || ""}
              </Text>
              <Text style={styles.tableColname}>
                {student.candidatE_NAME || ""}
              </Text>
              <Text style={styles.tableColgender}>{student.gender || ""}</Text>
              <Text style={styles.tableCol}>{student.castE_NAME || ""}</Text>
              <Text style={styles.tableCol}>
                {student.prinT_CATEGORY || ""}
              </Text>
              <Text style={styles.tableColregistration}>
                {student.exaM_FEES || ""}
              </Text>
              <Text style={styles.tableCollate}>{student.latE_FEE || ""}</Text>
              <Text style={styles.tableCollate}>
                {(
                  Number(student.exaM_FEES || 0) + Number(student.latE_FEE || 0)
                ).toFixed(2)}
              </Text>
            </View>
          ))}

          {/* Table Footer for Total Fees */}
          <View style={styles.tableRow}>
            <Text
              style={{
                ...styles.tableCol,
                width: "108.32%",
                textAlign: "right",
                fontWeight: "bold",
              }}
            >
              Total Fees: {totalFees.toFixed(2)}
            </Text>
          </View>
        </View>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default AnnexurePDF;
